/** Width of collapsed icon rails (app sidebar, email sidebar, DB browser). */
export const COLLAPSED_RAIL_WIDTH_PX = 64;
